var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSatisfied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.2084 32.0835C47.6246 32.0835 49.5834 30.1247 49.5834 27.7085C49.5834 25.2923 47.6246 23.3335 45.2084 23.3335C42.7921 23.3335 40.8334 25.2923 40.8334 27.7085C40.8334 30.1247 42.7921 32.0835 45.2084 32.0835Z",
    fill: "#F6867A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7916 32.0835C27.2079 32.0835 29.1666 30.1247 29.1666 27.7085C29.1666 25.2923 27.2079 23.3335 24.7916 23.3335C22.3754 23.3335 20.4166 25.2923 20.4166 27.7085C20.4166 30.1247 22.3754 32.0835 24.7916 32.0835Z",
    fill: "#F6867A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 46.6668C30.6834 46.6668 26.9792 44.3043 24.9375 40.8335H20.0667C21.2386 43.8408 23.2911 46.4242 25.9556 48.2456C28.6201 50.0669 31.7725 51.0414 35 51.0414C38.2276 51.0414 41.3799 50.0669 44.0445 48.2456C46.709 46.4242 48.7615 43.8408 49.9334 40.8335H45.0625C43.0209 44.3043 39.3167 46.6668 35 46.6668ZM34.9709 5.8335C18.8709 5.8335 5.83337 18.9002 5.83337 35.0002C5.83337 51.1002 18.8709 64.1668 34.9709 64.1668C51.1 64.1668 64.1667 51.1002 64.1667 35.0002C64.1667 18.9002 51.1 5.8335 34.9709 5.8335ZM35 58.3335C22.1084 58.3335 11.6667 47.8918 11.6667 35.0002C11.6667 22.1085 22.1084 11.6668 35 11.6668C47.8917 11.6668 58.3334 22.1085 58.3334 35.0002C58.3334 47.8918 47.8917 58.3335 35 58.3335Z",
    fill: "#F6867A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatisfied);
export default __webpack_public_path__ + "static/media/satisfied.1211cd801569a181ffe6584aaa378cd8.svg";
export { ForwardRef as ReactComponent };